import { IconLoading } from '@arco-design/web-react/icon';
import React from 'react';

interface IProps {
  style?: React.CSSProperties;
  className?: string;
}

export const Loading = (props: IProps) => {
  return (
    <div
      style={{
        width: '100%',
        height: 800,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(props.style ?? {}),
      }}
      className={props.className ?? ''}
    >
      <IconLoading style={{ width: 100, height: 100, color: '#ccc' }} />
    </div>
  );
};
